<template>
    <v-card
      class="mx-auto pa-5 overflow-visible"
      outlined
    >
      <div class="chart">
        <div class="chart-title chart-title--multiLine display-2">
          Tỉ lệ chốt
        </div>
        <div class="chart-content">
          <div class="chart-item">
            <span class="font-weight-bold">Tỉ lệ chốt</span>
            <span class="chart-bg chart-bg--male"></span>
          </div>
        </div>
      </div>
      <chartist
        :data="multipleLine.data"
        :options="multipleLine.options"
        type="Line"
        style="max-height: 300px;"
        class="mt-10 chart-multi chart-fix"
      />
    </v-card>
</template>
<script>
  import * as ChartistTooltips from 'chartist-plugin-tooltips';
  export default {
    props: {
      dataChart: {
        type: Object,
        default: () => {},
      }
    },
    created () {
      this.multipleLine.data.series = [
        this.dataChart.departmentInitLatchRatio.map(d => ({ meta: 'Tỉ lệ (%):', value: d })),
      ]
    },
    data() {
      return {
        multipleLine: {
          data: {
            labels: this.dataChart.labels,
            series: [
            ],
          },
          options: {
            fullWidth: true,
            low: 0,
            axisY: {
              onlyInteger: true,
            },
            chartPadding: {
              top: 0,
              right: 20,
              bottom: 0,
              left: 20,
            },
            plugins: [this.$chartist.plugins.tooltip()]
          },
        },
      }
    },
  }
</script>